
<template>
  <div class="top4">
    <div class="boxtitle">
      <div class="bleft">
        <div class="btitle">
          <span>往届优秀案例</span>
        </div>
      </div>
      <div class="bright">
        <div class="brm">
          <input type="text" placeholder="请输入案例或作者姓名" v-model="text">
          <img src="../../../assets/img/reading/x.png" v-show="text" alt="">
        </div>
        <div class="brr" @click="GetVideoList()">
          <img src="../../../assets/img/icon/search.png" alt="">
        </div>
      </div>
    </div>
    <div class="t4fbox">
      <div class="t4box" v-for="(item, index) in videolist" :style="index%5==0?'margin-left:0':''" :key="index">
        <div class="t4bt1" @click="toShipin(item)" :style="'background-image: url(' + item.urllist[0].resUrl+'?spm=qipa250&x-oss-process=video/snapshot,t_3000,f_jpg,w_150,h_210,m_fast,ar_auto' + ');'">
          <div style="display: flex;justify-content: center;align-items: center; margin-top: 50%;">
            <img src="../../../assets/img/bofang.png" style="width: 50px; height: 50px;" />
          </div>
        </div>
        <div class="t4bt2">
          <el-popover placement="top-start" width="200" trigger="hover" :content="item.title">
            <div slot="reference">{{item.title}}</div>
          </el-popover>
        </div>
        <div class="t4bt3">
          <span>作者：{{item.userName}}</span>
        </div>
        <div class="t4bt4">
          <div class="t4bt4r">
            <el-popover placement="top-start" width="170" trigger="hover" :content="item.uint">
              <div slot="reference">{{ellipsis(item.uint)}}</div>
            </el-popover>
          </div>
        </div>
      </div>
      <div class="nobox" v-show="videolist.length==0">未找到相关案例</div>
    </div>
    <div class="t4bot" @click="toMore" v-show="page.total>videolist.length&&page.total>page.limit">
      <span>加载更多案例</span>
      <img src="../../../assets/img/reading/xia.png" alt="">
    </div>
    <div class="t4bot" @click="toSouqi" v-show="page.total==videolist.length&&page.total>page.limit">
      <span>收起</span>
      <img src="../../../assets/img/reading/xia.png" style="transform: rotate(180deg)" alt="">
    </div>
    <el-dialog :visible.sync="isShipin"  :title="shipinTitle" :before-close="shipinClose" width="750px">
      <div id="shipin"></div>
    </el-dialog>
  </div>
</template>
<script>
import Player from 'xgplayer';
export default {
    data() {
        return {
            text: '',
            stext: '',
            list: [],
            videolist: [],
            isjieshao: false,
            info: '',
            page: {
                index: 1,
                limit: 15,
                total: 0,
            },
            uid: 0,
            player: null,
            isShipin: false,
            shipinTitle: '',
        };
    },
    created() {
        if (localStorage.getItem('ResData')) {
            this.uid = Number(JSON.parse(localStorage.getItem('ResData')).id);
        }
        this.GetVideoList();
    },
    methods: {
        GetVideoList() {
            this.page.index = 1;
            this.stext = this.text;
            this.httphelper
                .post('https://pefmapi.gp519.com/api/WebSiteApi/GetWorksPushWebSitePageList', {
                    keyword: this.stext,
                    page: this.page.index,
                    limit: this.page.limit,
                })
                .then(res => {
                    this.videolist = res.data.data;
                    this.page.total = res.data.totalcount;
                    // console.log(res.data.data);
                });
        },
        toMore() {
            this.page.index++;
            this.httphelper
                .post('https://pefmapi.gp519.com/api/WebSiteApi/GetWorksPushWebSitePageList', {
                    keyword: this.stext,
                    page: this.page.index,
                    limit: this.page.limit,
                })
                .then(res => {
                    if (res.data.code == 200) {
                        this.videolist = this.videolist.concat(res.data.data);
                    }
                });
        },
        toSouqi() {
            this.page.index = 1;
            this.videolist = this.videolist.slice(0, this.page.limit);
        },
        ellipsis(value) {
            if (!value) return '';
            if (value.length > 8) {
                return value.slice(0, 8) + '...';
            }
            return value;
        },
        /** @description 弹出视频 */
        toShipin(item) {
            this.shipinTitle = item.title;
            this.isShipin = true;
            var test1 = setTimeout(() => {
                this.player = new Player({
                    id: 'shipin',
                    url: item.urllist[0].resUrl,
                    autoplay: true,
                    playsinline: true,
                    width: '100%',
                    height: 'auto'//'800px',
                });
                clearTimeout(test1);
            }, 100);
        },
        /** @description 关闭弹出视频 */
        shipinClose() {
            if (this.player != null) {
                this.player.destroy();
                this.player = null;
            }
            this.isShipin = false;
        },
    },
};
</script>
<style lang="scss" scoped>
.top4 {
    width: 1200px;
    margin: 0 auto 30px;
    .boxtitle {
        width: 100%;
        border-bottom: 1px solid #eee;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 20px 0;
        .btitle {
            display: inline-block;
            font-size: 26px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #000000;
            line-height: 26px;
            padding: 15px 0;
            border-bottom: 1px solid #000;
        }
        .bright {
            width: 350px;
            height: 36px;
            background: #ffffff;
            border: 1px solid #007380;
            border-radius: 18px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            box-sizing: border-box;
            position: relative;
            .brl {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #000000;
                line-height: 16px;
                margin: 0 10px 0 15px;
                cursor: pointer;
                width: 71px;
                img {
                    margin-left: 5px;
                }
                span {
                    width: 56px;
                    text-align: center;
                }
            }
            .brm {
                height: 26px;
                width: 280px;
                padding-left: 14px;
                display: flex;
                align-items: center;
                input {
                    height: 26px;
                    flex: 1;
                    border: none;
                    font-size: 15px;
                }
                img {
                    width: 18px;
                    height: 18px;
                    margin: 9px;
                    cursor: pointer;
                }
            }
            .brr {
                width: 54px;
                height: 36px;
                background: #007380;
                border-radius: 0px 18px 18px 0px;
                cursor: pointer;
                overflow: hidden;
                img {
                    margin-left: 5px;
                }
            }
            .brzm {
                position: absolute;
                width: 350px;
                height: 100px;
                background: #ffffff;
                border: 1px solid #007380;
                border-radius: 18px;
                top: 40px;
                box-sizing: border-box;
                display: flex;
                flex-wrap: wrap;
                padding: 6px 7px;
                .zm {
                    width: 37px;
                    text-align: center;
                    line-height: 28px;
                    font-size: 14px;
                    cursor: pointer;
                }
            }
        }
    }
    ::v-deep .el-alert__title {
        font-size: 16px;
        line-height: 30px;
    }
    .t4fbox {
        width: 1200px;
        display: flex;
        flex-wrap: wrap;
        margin-top: 30px;
        cursor: pointer;
    }
    .t4box {
        width: 216px;
        height: 407px;
        // height: 365px;
        border-radius: 5px;
        margin-bottom: 20px;
        margin-left: 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .t4bt1 {
            width: 157px;
            height: 210px;
            background: #ffffff;
            box-shadow: 8px 6px 15px 0px rgba(0, 0, 0, 0.15);
            margin-top: 10px;
            margin-bottom: 5px;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .t4bt2 {
            height: 52px;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #000000;
            line-height: 26px;
            margin: 15px 20px;
            display: -webkit-box;
            text-overflow: ellipsis;
            overflow: hidden;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
        }
        .t4bt3 {
            width: 170px;
            height: 32px;
            background: #f5f7fa;
            border-radius: 3px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #000000;
            line-height: 32px;
            text-align: center;
            margin-bottom: 10px;
        }
        .t4bt4 {
            width: 170px;
            display: flex;
            justify-content: space-between;
            text-align: center;
            line-height: 28px;
            .t4bt4l {
                width: 65px;
                height: 30px;
                background: #fcf6f6;
                border: 1px solid #d7000b;
                border-radius: 3px;
                box-sizing: border-box;
                color: #d7000b;
                cursor: pointer;
            }
            .t4bt4r {
                width: 170px;
                height: 30px;
                background: #def3f3;
                border: 1px solid #0b8586;
                color: #0b8586;
                border-radius: 3px;
                box-sizing: border-box;
                cursor: pointer;
            }
        }
    }
    .t4box:hover {
        box-shadow: 6px 17px 23px 0px rgba(11, 133, 134, 0.25);
        border-radius: 5px;
        .t4bt4l {
            background: #d7000b;
            color: #fff;
        }
        .t4bt4r {
            background: #0b8586;
            color: #fff;
        }
    }
    .nobox {
        width: 100%;
        line-height: 100px;
        text-align: center;
    }
    .jieshao {
        ::v-deep .el-dialog {
            width: 600px;
            border-radius: 5px;
        }
        ::v-deep .el-dialog__header {
            padding: 0;
        }
        ::v-deep .el-dialog__body {
            padding: 45px 35px 50px;
            display: flex;
            img {
                width: 154px;
                height: 221px;
                box-shadow: 12px 9px 15px 0px rgba(0, 0, 0, 0.22);
                margin-right: 30px;
                margin-top: 5px;
            }
            .jsRight {
                display: flex;
                flex-direction: column;
                line-height: 22px;
                p {
                    margin: 5px 0;
                }
            }
        }
    }
    .t4bot {
        width: 350px;
        height: 40px;
        background: #0b8586;
        border-radius: 20px;
        margin: 10px auto;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        line-height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        img {
            margin-left: 10px;
        }
    }
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
    color:#1E9FFF
}
::v-deep .el-dialog__headerbtn {
   right: 10px !important;
//    color: #000;
}
</style>